import React from 'react';
import 'babel-polyfill';
import Footer from './footer';
import Cleave from 'cleave.js/react';
import { getAftHeader } from './util';
import axios, { AxiosResponse } from 'axios';
import FormProgress from './formprogress';

{/*
const FormWrapper = ({ children, lead }) => {
    return (<>
        <div className="container container-narrow bg-white px-5">
            <div className="text-center pt-4 pb-4">
                <a href="./"><img className="d-block mx-auto" src="img/beth-israel-lahey-health-logo-web-crop2.png" alt="Beth Israel Lahey Health" style={{ maxWidth: "320px" }} /></a>
                {lead && <p className="lead">{lead}</p>}
            </div>

            <div className="row">
                <div className="col-md-12">
                    <form className="needs-validation" noValidate>
                        {children}
                    </form>
                </div>
            </div>
        </div>
        <Footer />
    </>);
}
*/}

const FormWrapper = ({ children, currentStep }) => {
    return (<>
        <div className="container container-narrow bg-white px-4 px-sm-5">
            {currentStep > 0 ?
                <><div className="pt-4 row">
                    <div className="col-lg-4">
                        <a href="./"><img className="d-block" src="img/beth-israel-lahey-health-logo-web-crop2.png" alt="Beth Israel Lahey Health" style={{ maxWidth: "320px", marginLeft: "-10px" }} /></a>
                    </div>
                    <div className="col-lg-8" style={{ marginTop: "18px" }}>
                        {currentStep > 0 && <FormProgress currentStep={currentStep} />}
                    </div>
                </div></>
                : <div className="text-center pt-4 pb-4">
                    <a href="./"><img className="d-block mx-auto" src="img/beth-israel-lahey-health-logo-web-crop2.png" alt="Beth Israel Lahey Health" style={{ maxWidth: "320px" }} /></a>
                </div>
            }            
            
            <div className="row">
                <div className="col-md-12">
                    <form className="needs-validation" noValidate>
                        {children}
                    </form>
                </div>
            </div>
        </div>
        
        <Footer />
    </>);
}


export default FormWrapper;

interface IFormTextFieldProps {
    className?: string,
    id: string,
    label: string,
    defaultValue?: string,
    placeholder?: string,
    maxLength?: number,
    required?: boolean,
    onChange?: React.ChangeEventHandler<HTMLInputElement>,
    mask?: string,
    value?: string,
    invalidText?: string,
    autoComplete?: string,
    label2?: any,
    invalidFeedbackClassName?: string
}

export const FormTextField = (props: IFormTextFieldProps) => {
    let maskOptions = {}
    if (props.mask) {
        if (props.mask === 'date') {
            maskOptions = { date: true, datePattern: ['m', 'd', 'Y'] }
        } else if (props.mask === 'zip' || props.mask === 'number') {
            maskOptions = { numericOnly: true }
        } else if (props.mask === 'phone') {
            maskOptions = { blocks: [3, 3, 4], delimiter: '-', numericOnly: true }
        }
    }

    function defaultOnChange(e: any) {
        if (e.target) {
            e.target.classList.remove("is-invalid");
        }
        if (props.onChange) {
            props.onChange(e);
        }
    }

    return (
        <div className={props.className || "col-md-6 mb-3"}>
            <label htmlFor={props.id}>{props.label}{props.required && "*"} {props.label2}</label>
            {
                props.mask ?
                    <Cleave placeholder={props.placeholder}
                        options={maskOptions}
                        id={props.id}
                        value={props.value}
                        onChange={defaultOnChange}
                        className="form-control"
                        maxLength={props.maxLength}
                        autoComplete={props.autoComplete}
                        style={{ background: "none" }}
                    /> :
                    props.defaultValue ?
                        <input type="text" className="form-control" id={props.id}
                            placeholder={props.placeholder} defaultValue={props.defaultValue}
                            required={props.required} maxLength={props.maxLength} onChange={defaultOnChange} autoComplete={props.autoComplete} /> :
                        <input type="text" className="form-control" id={props.id}
                            placeholder={props.placeholder} value={props.value}
                            required={props.required} maxLength={props.maxLength} onChange={defaultOnChange} autoComplete={props.autoComplete} />
            }

            <div className="invalid-feedback">{props.invalidText || "Required"}</div>
        </div>
    );
}

interface IFormSelectProps {
    className?: string,
    id: string,
    label: string,
    defaultValue?: string,
    required?: boolean,
    onChange?: React.ChangeEventHandler<HTMLSelectElement>,
    value?: string,
    hideChoose?: boolean,
    options: any[]
}

export const FormSelect = (props: IFormSelectProps) => {
    function defaultOnChange(e: any) {
        if (e.target) {
            e.target.classList.remove("is-invalid");
        }
        if (props.onChange) {
            props.onChange(e);
        }
    }

    return (
        <div className={props.className || "col-md-6 mb-3"}>
            <label htmlFor={props.id}>{props.label}{props.required && "*"}</label>
            <select className="custom-select d-block w-100" id={props.id} onChange={defaultOnChange}>
                {!props.hideChoose && <option value="">Choose...</option>}
                {props.options.map(o =>
                    <option selected={o.value ? props.defaultValue === o.value : props.defaultValue === o} value={o.value || o.name || o}>{o.name || o}</option>
                )}
            </select>
            <div className="invalid-feedback">Required</div>
        </div>
    )
}

interface IFormRadioProps {
    className?: string,
    id: string,
    label?: string,
    required?: boolean,
    onChange?: React.ChangeEventHandler<HTMLInputElement>,
    value?: string,
    checked?: boolean,
    children?: any,
    name: string
}

export const FormRadio = (props: IFormRadioProps) => {
    function defaultOnChange(e: any) {
        if (e.target) {
            e.target.classList.remove("is-invalid");
        }
        if (props.onChange) {
            props.onChange(e);
        }
    }

    return (
        <div className="form-check mb-3">
            <input className="form-check-input" type="radio" id={props.id} name={props.name} defaultChecked={props.checked} required={props.required} value={props.value} onChange={defaultOnChange} />
            <label className="form-check-label" htmlFor={props.id}>
                {props.children || props.label}
            </label>
        </div>
    );
}

export const FormSubmit = (action: string, url: string, fields: string[], data: any, success: Function, postError: Function, customError: Function, errorMap: any = null) => {
    for (let i = 0; i < fields.length; i++) {
        let name = fields[i];
        let e = document.getElementById(name) as any;
        if (e) {
            if (e.type !== "checkbox") {
                e.classList.remove("is-invalid");
            }
            data[name] = e.options ? e.value :
                e.type === "checkbox" ? e.checked :
                    e.value;
            e.style.background = "none";
        }
    }

    var grecaptcha = (window as any).grecaptcha;
    grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute((window as any).RECAPTCHA_KEY, { action: action }).then(function (token) {
            var h = getAftHeader();
            h.headers["recaptcha-token"] = token;

            axios.post(url, data, h)
                .then((response) => success(response))
                .catch((error) => {
                    try {                        
                        let r = error.response.data;
                        if (r.error === "INPUT_VALIDATION_ERROR") {
                            for (let i = 0; i < r.errors.length; i++) {
                                var err = r.errors[i];
                                var el = document.getElementById(err.field);
                                let p = el.parentElement;
                                if (err.errorType === "MaxLengthError") {
                                    (p.getElementsByClassName("invalid-feedback")[0] as HTMLDivElement).innerText =
                                        "Please limit " + (p.getElementsByTagName("label")[0] as HTMLLabelElement).innerText + " to " + err.maxLength + " characters";
                                } else if (err.errorType === "CustomError") {
                                    if (errorMap && errorMap[err.message]) {                                        
                                        (p.getElementsByClassName("invalid-feedback")[0] as HTMLDivElement).innerHTML = errorMap[err.message];
                                    } else {
                                        (p.getElementsByClassName("invalid-feedback")[0] as HTMLDivElement).innerText = err.message || "Invalid value";
                                    }
                                }
                                el.classList.add("is-invalid");
                            }
                            for (let i = 0; i < fields.length; i++) {
                                if (r.errors.filter(e => e.field === fields[i]).length > 0) {
                                    var el = document.getElementById(fields[i]);
                                    let p = el.parentElement;                                    
                                    el.focus();
                                    var label = p.getElementsByTagName("label");
                                    if (label.length === 0) {
                                        label = p.parentElement.getElementsByTagName("label");
                                    }
                                    if (label && label.length >= 1) {
                                        label[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
                                    }                                    
                                    break;
                                }
                            }

                            if (postError) {
                                postError(r);
                            }
                        } else {
                            if (customError) {
                                customError(r);
                            }
                        }
                    } catch {
                        customError(error);
                    }
                })
        })
    });
}